export const integrationsData = (companyIntegrations) => [
    {
        name: 'SkyBox',
        logo: '/logos/skybox-logo.png',
        description: 'Connect your SkyBox account to manage your purchases and invoices.',
        lastSync: companyIntegrations.integrations_data.skybox_connected ? companyIntegrations.integrations_data.last_synced : null,
        isConnected: companyIntegrations.integrations_data.skybox_connected,
    },
    // {
    //     name: 'Automatiq Indy',
    //     logo: '/logos/lysted-logo.png',
    //     description: 'Connect your Automaitq Indy account to manage your purchases.',
    //     lastSync: companyIntegrations.automatiq_indy_connected
    //         ? companyIntegrations.last_synced
    //         : null,
    //     isConnected: companyIntegrations.automatiq_indy_connected,
    // },
    // {
    //     name: 'StubHub',
    //     logo: '/logos/stubhub-logo.png',
    //     description: 'Connect your StubHub account to manage your inventory.',
    // },
];

export const automatedIntegrationsData = (companyIntegrations) => [
    {
        name: 'Automatiq Sync',
        logo: '/logos/automatiq-logo.png',
        description: 'Connect your Automaitq Sync account to manage your inventory.',
        lastSync: companyIntegrations.integrations_data.automatiq_sync_connected
            ? companyIntegrations.integrations_data.last_synced
            : null,
        isConnected: companyIntegrations.integrations_data.automatiq_sync_connected,
    },
];
